import { createIcon } from "@chakra-ui/icons";

export const FilterIcon = createIcon({
  displayName: "FilterIcon",
  viewBox: "0 0 16 16",
  path: (
    <path
      d="M2.25726 3.77791C1.75303 3.21437 1.50092 2.93259 1.49141 2.69312C1.48315 2.48509 1.57255 2.28515 1.73309 2.15259C1.91789 2 2.29599 2 3.05219 2H12.9475C13.7037 2 14.0818 2 14.2666 2.15259C14.4271 2.28515 14.5165 2.48509 14.5082 2.69312C14.4987 2.93259 14.2466 3.21437 13.7424 3.77791L9.93824 8.02962C9.83773 8.14196 9.78747 8.19813 9.75164 8.26205C9.71985 8.31875 9.69653 8.37978 9.68242 8.44323C9.6665 8.51476 9.6665 8.59013 9.6665 8.74087V12.3056C9.6665 12.436 9.6665 12.5011 9.64547 12.5575C9.62689 12.6073 9.59667 12.6519 9.55733 12.6877C9.51281 12.7281 9.45229 12.7524 9.33124 12.8008L7.06457 13.7074C6.81954 13.8054 6.69703 13.8545 6.59868 13.834C6.51267 13.8161 6.4372 13.765 6.38866 13.6918C6.33316 13.6081 6.33316 13.4762 6.33316 13.2122V8.74087C6.33316 8.59013 6.33316 8.51476 6.31724 8.44323C6.30313 8.37978 6.27981 8.31875 6.24802 8.26205C6.21219 8.19813 6.16193 8.14196 6.06142 8.02962L2.25726 3.77791Z"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  defaultProps: {
    width: "16px",
    height: "16px",
  },
});
